var _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinnerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4087_32990",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 9.58144 15.5313 11.1274 14.6531 12.4426C13.7749 13.7578 12.5266 14.7831 11.0659 15.3892C9.60519 15.9953 7.99763 16.1548 6.44631 15.8477C4.89498 15.5405 3.46949 14.7805 2.34991 13.6636C1.23033 12.5467 0.466895 11.123 0.156057 9.57244C-0.154782 8.02185 0.000919483 6.41392 0.60349 4.95178C1.20606 3.48964 2.22847 2.23889 3.54154 1.35755C4.85462 0.476202 6.39946 0.00380079 7.98089 2.28282e-05L8 8H16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 9.58144 15.5313 11.1274 14.6531 12.4426C13.7749 13.7578 12.5266 14.7831 11.0659 15.3892C9.60519 15.9953 7.99763 16.1548 6.44631 15.8477C4.89498 15.5405 3.46949 14.7805 2.34991 13.6636C1.23033 12.5467 0.466895 11.123 0.156057 9.57244C-0.154782 8.02185 0.000919483 6.41392 0.60349 4.95178C1.20606 3.48964 2.22847 2.23889 3.54154 1.35755C4.85462 0.476202 6.39946 0.00380079 7.98089 2.28282e-05L8 8H16Z",
    stroke: "white",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_4087_32990)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerIcon);
export default __webpack_public_path__ + "static/media/SpinnerIcon.0a897007750f229dd55a6c35cdb9700d.svg";
export { ForwardRef as ReactComponent };